
<div class="auth-container">
  <div class="auth-form">
    <h2 class="form-header text-center">Verifierar din e-postadress...</h2>
    @if (status === 'success') {
      <div class="alert alert-success mt-4">
        <i class="fa fa-check-circle me-2"></i>
        Din e-postadress är nu bekräftad!
        <div class="mt-3">
          <button class="btn btn-primary" (click)="goToLogin()">
            Logga in
          </button>
        </div>
      </div>
    }

    @if (status === 'error') {
      <div class="alert alert-danger mt-4">
        <i class="fa fa-times-circle me-2"></i>
        Länken är ogiltig eller har gått ut. Kontrollera mejlet och försök igen.
        <div class="mt-3">
          <a class="btn btn-primary" routerLink="/login">
            Tillbaka till inloggning
          </a>
        </div>
      </div>
    }

  </div>
</div>